export const CANCEL_TX = 'Cancel'
